import { Map, Record } from 'immutable'
import { handleBatch } from '../actionBatcher'

import * as actionTypes from './actionTypes'

const UpdateState = Record({
  ongoing: false,
  success: false,
  error: null,
})

const InitialState = Record(
  {
    map: Map(),
    adminChannels: Map(),
    updateChannelName: Map(),
  },
  'channels'
)

const ChannelsReducer = (state = new InitialState(), action) => {
  switch (action.type) {
    case actionTypes.CHANNEL_FETCHED: {
      return handleBatch(state, action, (state, action) => {
        const { channelId, channel } = action.payload
        return state.update('map', map => map.set(channelId, channel))
      })
    }
    case actionTypes.CHANNELS_FETCHED: {
      const { payload } = action
      return payload.reduce((state, channel) => {
        return state.update('map', map => map.set(channel.id, channel))
      }, state)
    }
    case actionTypes.ADMIN_CHANNEL_FETCHED: {
      return handleBatch(state, action, (state, action) => {
        const { channelId, channel } = action.payload
        return state.update('adminChannels', map => map.set(channelId, channel))
      })
    }
    case actionTypes.DELETE_CHANNEL_SUCCESS: {
      return state.deleteIn(['map', action.payload.channelId])
    }
    case actionTypes.DELETE_ADMIN_CHANNEL_SUCCESS: {
      return state.deleteIn(['adminChannels', action.payload.channelId])
    }
    case actionTypes.CHANGE_CHANNEL_NAME_START: {
      const { channelId } = action.meta.action.meta
      return state.setIn(
        ['updateChannelName', channelId],
        new UpdateState({ ongoing: true })
      )
    }
    case actionTypes.CHANGE_CHANNEL_NAME_SUCCESS: {
      const { channelId } = action.meta.action.meta
      return state.updateIn(['updateChannelName', channelId], record =>
        record.merge({ ongoing: false, success: true })
      )
    }
    case actionTypes.CHANGE_CHANNEL_NAME_ERROR: {
      const error = action.payload
      const { channelId } = action.meta.action.meta
      return state.updateIn(['updateChannelName', channelId], record =>
        record.merge({ ongoing: false, error })
      )
    }
    default:
      return state
  }
}

export default ChannelsReducer
